window.PermissaoSenhaVendaController = ControllerBase.extend({
    name: 'PermissaoSenhaVendaController',
    framework: 'knockout',   
    bindingRegion: "#form-validar-senha-venda",
    autorizado: false,

    ajax: function () {
        return {
            url: "/Comum/_PermissaoSenhaVenda",
            type: "post",
            cache: false,
            data: { permissoes: this.permissoes}
        };
    },

    aposBinding: function () {
        this.mostrarModal();
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    mostrarModal: function () {
        $("#modalPermissao").modal("show");
        this.verificarModalFechou()
    },

    verificarPermissaoSenhaVenda: function () {
        var self = this;
      
        global.ajax({
            url: "/Comum/ValidarPermissaoSenhaVenda",
            type: "post",
            data: {
                codigoSenha: self.model.senha,
                permissoes: self.permissoes
            },
            success: function (data) {
                if (!data || data.HasErrors) {
                    self.autorizado = false;
                    return false;
                }
                $('#modalPermissao').modal('hide')
                self.autorizado = true;
                return true;
            }
        });
    },

    verificarModalFechou: function () {
        var self = this;
        $('#modalPermissao').on('hidden.bs.modal', $.proxy(function () {

            if (typeof self.autorizadoCallback != "undefined") {
                self.autorizadoCallback(self.autorizado);
            }
        }));
    }

});